<template>
  <div class="view">
    <header class="header">
      <div class="header__inner container">
        <div>
          <router-link :to="{ name: 'index' }" v-if="$store.getters.branding || !$route.params.surveyRef">
            <img :src="logoUrl" alt="rradarsurvey"
              :class="['header__logo', { 'half-width': branding === 'rrelentless' }]">
          </router-link>
        </div>
        <div class="header__info" v-if="isAuthenticated">
          <div class="header__info-section"><router-link :to="{ name: 'admin-index' }" v-if="isAdminUser"
              class="button">Admin Area</router-link></div>
          <div class="header__info-section">
            <div>
              <strong>Logged in as</strong><br>
              {{ fullName }}
              <span class="small">
                (<a href="" @click.prevent="logout">Log Out</a>)
              </span>
            </div>
          </div>
        </div>
        <div class="header__info" v-else>
          <router-link :to="{ name: 'login' }" class="header__login button">Login</router-link>
        </div>
      </div>
    </header>

    <div class="message" :class="[{ 'open': message.text }, message.messageType]">
      {{ message.text }}
    </div>

    <v-dialog />

    <router-view class="container"></router-view>

    <footer class="footer">
      <div class="container footer__inner">
        <p><a href="http://www.rradar.com" v-if="branding || !$route.params.surveyRef">
            <img :src="logoUrl" :alt="branding" :class="['footer__logo', {
              'half-width':
                branding === 'rrelentless'
            }]">
          </a></p>
        <p>&copy; {{ new Date().getFullYear() }} All Rights Reserved.
          <span class="footer__links"><a :href="termsUrl">Terms & Conditions</a></span>
          <span class="footer__links" v-if="legalNotices"><a :href="legalNotices">Legal Notices</a></span>
          <span class="footer__links"><a :href="privacyUrl">Privacy Notice</a></span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'app',

  computed: {
    ...mapState([
      'message',
    ]),

    ...mapGetters([
      'isAuthenticated',
      'isAdminUser',
      'inAdminArea',
      'fullName'
    ]),

    branding() {
      return this.$store.getters.branding || 'rradar';
    },

    logoUrl() {
      return require(`../assets/images/${this.branding}-logo.svg`);
    },

    termsUrl() {
      return 'https://www.rradar.com/terms-conditions';
    },

    privacyUrl() {
      if (this.branding === 'rrelentless') return 'https://landing.rradar.com/rrelentless-survey/privacy_and_data_notice.html';

      return 'https://www.rradar.com/privacy-notice';
    },

    legalNotices() {
      if (this.branding === 'rrelentless') return 'https://landing.rradar.com/rrelentless-survey/legal_notices.html';

      return null;
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.axios.get('deauth').then(response => window.location = response.data);
      });
    },
  },
};
</script>
